import Button from "../core/Button";
import GameConfig from "../core/data/GameConfig";
import Medal from "../game/Medal";
import GameColors from "../GameColors";
import PlayerData from "../PlayerData";
import LevelSelectScene from "../scenes/LevelSelectScene";
import Fonts from "../utils/Fonts";

export default class LevelSelectButton extends Phaser.GameObjects.Container {
	private levelButton: Button;

	private isDay = true;
	private levelLocked: boolean;
	nightLevelLocked: boolean;
	private lockIcon: Phaser.GameObjects.Image;
	private lockBacker: Phaser.GameObjects.Image;
	private levelText: Phaser.GameObjects.Text;
	private levelMedal: Phaser.GameObjects.Image;
	private index: number;

	scene: LevelSelectScene;

	willPlayUnlock: boolean;

	constructor(
		scene: LevelSelectScene,
		index: number,
		levelLocked: boolean,
		nightLevelLocked: boolean,
		playMedalAnim: boolean,
		playUnlockAnim: boolean
	) {
		super(scene, 0, 0);
		this.scene = scene;
		this.index = index;
		this.levelLocked = levelLocked;
		this.nightLevelLocked = nightLevelLocked;
		this.willPlayUnlock = playUnlockAnim;

		const saveData = PlayerData.Instance.saveData;
		let levelButton: Button;
		if (index > 4) levelButton = this.levelButton = scene.add.button(0, 0, "level" + (index - 4) + "Night", 0, this.play, this, true);
		else levelButton = this.levelButton = scene.add.button(0, 0, "level" + index + "Day", 0, this.play, this, true);
		this.add(levelButton);
		this.setSize(levelButton.width, levelButton.height);
		const lockBacker = (this.lockBacker = scene.add.image(0, 0, "levelLocked"));
		this.add(lockBacker);
		if (levelLocked || playUnlockAnim) {
			levelButton.disableInteractive();
		} else lockBacker.setVisible(false);

		const bestMedal = saveData.medalsEarned[index - 1];
		let medal: Phaser.GameObjects.Image;
		if (bestMedal != Medal.None) {
			medal = this.levelMedal = scene.add.image(0, 0, "medalIcon" + bestMedal);
			this.add(medal);
		}

		const numberBaseGreen = scene.add.image(0, 0, "numberBaseGreen");
		const numberBase = scene.add.image(0, 0, "numberBase");
		const uiStyle = {
			color: GameColors.PURPLE,
			fontFamily: Fonts.MontserratBold,
			fontSize: "70px",
			align: "center",
		};
		const levelText = (this.levelText = scene.add.text(0, 0, "" + index, uiStyle));
		levelText.setOrigin(0.5, 0.5);
		this.add([numberBaseGreen, numberBase, levelText]);

		const lockedIcon = (this.lockIcon = scene.add.image(0, 0, "lockIcon"));
		this.add(lockedIcon);
		if ((!levelLocked && !playUnlockAnim) || (!nightLevelLocked && index > 4)) lockedIcon.setVisible(false);

		scene.alignIn.TopCenter(numberBaseGreen, levelButton, 0, 10);
		scene.alignIn.Center(numberBase, numberBaseGreen);
		scene.alignIn.Center(levelText, numberBase);
		scene.alignIn.BottomCenter(lockedIcon, levelButton, 0, 10);

		if (medal) {
			scene.alignIn.BottomCenter(medal, levelButton, -10, 60);
			if (playMedalAnim) this.playMedalAnim();
		}
		if (playUnlockAnim) this.playUnlockAnim();
	}

	setARIA(): void {
		const night = this.index > 4;
		const day = night ? "Night" : "Day";
		const index = this.index - (night ? 4 : 0);
		const locked = this.levelLocked ? "Locked" : "";
		this.levelButton.setARIA(`Training Area ${index} (${day}) ${locked}`);
	}

	play(): void {
		PlayerData.Instance.saveData.currentLevel = this.index - 1;
		PlayerData.Instance.saveData.levelToLoad = this.index - 1;
		PlayerData.Instance.saveData.lastLevelMedal = null;
		PlayerData.Instance.save();
		this.scene.scene.start("PreloaderScene", { destinationScene: "GameScene" });
		this.scene.scene.stop(this.scene.scene.key);
	}

	setDay(): void {
		this.isDay = true;
		if (this.index > 4) {
			this.index -= 4;
			this.levelText.setText("" + this.index);
		}
		if (!this.levelLocked) {
			const saveData = PlayerData.Instance.saveData;
			const bestMedal = saveData.medalsEarned[this.index - 1];
			if (bestMedal != Medal.None) this.levelMedal.setTexture("medalIcon" + bestMedal);
			else this.levelMedal.setTexture("medalIconNone");

			this.levelButton.setTexture("level" + this.index + "Day");
			this.levelButton.setInteractive();
			this.lockBacker.setVisible(false);
			this.lockIcon.setVisible(false);
		} else {
			this.lockBacker.setVisible(true);
			this.levelButton.disableInteractive();
			this.lockIcon.setVisible(true);
			this.levelMedal.setTexture("medalIconNone");
		}
		this.setARIA();
	}

	setNight(): void {
		this.isDay = false;
		if (this.index <= 4) {
			this.index += 4;
			this.levelText.setText("" + this.index);
		}
		if (!this.nightLevelLocked && !this.willPlayUnlock) {
			const saveData = PlayerData.Instance.saveData;
			const bestMedal = saveData.medalsEarned[this.index - 1];
			if (bestMedal != Medal.None) {
				this.levelMedal.setTexture("medalIcon" + bestMedal);
			} else this.levelMedal.setTexture("medalIconNone");
			this.levelButton.setInteractive();
			this.lockBacker.setVisible(false);
			this.lockIcon.setVisible(false);
		} else {
			this.lockBacker.setVisible(true);
			this.levelButton.disableInteractive();
			this.lockIcon.setVisible(true);
			this.levelMedal.setTexture("medalIconNone");
		}
		this.setARIA();
		this.levelButton.setTexture("level" + (this.index - 4) + "Night");
	}

	playMedalAnim(): void {
		if (this.index == 4) {
			this.scene.buttons[0].lockBacker.setVisible(false);
			this.scene.buttons[0].lockIcon.setVisible(false);
		}
		this.scene.tweens.add({
			targets: this.levelMedal,
			scale: { from: 1, to: 1.2 },
			duration: (GameConfig.get("medalTween") as number) / 2,
			ease: Phaser.Math.Easing.Back.Out,
			yoyo: true,
			onComplete: () => {
				if (this.index == 4) {
					this.scene.setNight();
					this.scene.buttons[0].lockBacker.setVisible(true);
					this.scene.buttons[0].lockIcon.setVisible(true);
					// this.scene.buttons[0].levelButton.setTexture("level1Night");
				}
			},
		});
	}

	playUnlockAnim(unlockDelay = GameConfig.get("unlockDelay") as number, revealDelay = GameConfig.get("revealDelay") as number): void {
		if (this.isDay == false) {
			this.lockBacker.setVisible(true);
			this.lockIcon.setVisible(true);
		}
		this.scene.time.delayedCall(unlockDelay, () => {
			this.scene.tweens.add({
				targets: this.lockIcon,
				angle: { from: this.lockIcon.angle, to: this.lockIcon.angle - 10 },
				duration: 50,
				ease: Phaser.Math.Easing.Quadratic.InOut,
				onComplete: () => {
					this.scene.tweens.add({
						targets: this.lockIcon,
						angle: { from: this.lockIcon.angle - 10, to: this.lockIcon.angle + 10 },
						duration: 100,
						yoyo: true,
						loop: 1,
						ease: Phaser.Math.Easing.Quadratic.InOut,
					});
				},
			});
		});

		this.scene.tweens.add({
			targets: [this.lockBacker, this.lockIcon],
			scale: { from: 1, to: 1.5 },
			alpha: { from: 1, to: 0 },
			duration: 750,
			ease: Phaser.Math.Easing.Back.Out,
			delay: unlockDelay + revealDelay,
			onComplete: () => {
				if (this.index == 5) {
					this.scene.checkDayComplete();
				}
				this.levelButton.setInteractive();
				this.willPlayUnlock = false;
			},
		});
	}
}
